module.exports = {
    title: {
        first: '域名健康诊断',
        second: '全面的智能化域名诊断，随时检查域名健康情况'
    },
    header: {
        headerName: '诊断项',
        headerResult: '诊断结果'
    },
    type: {
        whois: 'Whois诊断',
        http: 'HTTP诊断',
        ns: 'NS诊断',
        trace: 'dig+trace诊断'
    },
    column: {
        upTime: '更新时间',
        exTime: '到期时间',
        day: '天',
        deadline: '离域名到期还有'
    },
    status: {
        domainNormal: '该域名可以正常使用',
        open: '开通京东云解析服务',
        nsNormal: 'NS检测正常',
        dnsNormal: '该域名解析正常',
        not: '未检测',
        det: '检测',
        status: '状态',
        aStatus: 'A记录状态',
        fail: '检测失败'
    },
    detail: '详情',
    close: '收起',
    period: '。',
    flag: 'cn',
    tip: '请输入正确的域名'
};
